// extracted by mini-css-extract-plugin
export var btn = "OrderApprove-module--btn--cTsld";
export var container = "OrderApprove-module--container--CO49T";
export var logo = "OrderApprove-module--logo--wXqu7";